import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import Swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { NavigationEnd, Params, Router } from '@angular/router';
import { ReportsService } from 'src/app/features/reports/reports.service';
import {Location} from '@angular/common'; 
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-create-batch',
  templateUrl: './create-batch.component.html',
  styleUrls: ['./create-batch.component.scss']
})
export class CreateBatchComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  createBatchForm: FormGroup;
  Pricelists: Array<any>;
  previousUrl: string;


  constructor(private _location: Location, 
              private fb: FormBuilder, 
              private router: Router, 
              public dialog: MatDialog, 
              private reportsService: ReportsService, 
              private toastr:ToastrService) {
    super();
  }

  private initForm() {
    this.createBatchForm = this.fb.group({
      fromDate: ['', [Validators.required]],
      toDate: ['', [Validators.required]]
    })
  }

  get f() {
    return this.createBatchForm.controls;
  }
  
  ngOnInit(): void {
    super.ngOnInit()
    this.createBatchForm = this.fb.group({
      PricelistName: '',
      copyFrom: ''

    })
  }
  onCancel() { this.router.navigate(['features/providers/retailer/pricelist']);}
  onSubmit() {
   
    if (this.createBatchForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.createBatchForm)
        }else{
          this.router.navigate(['']);
        }
      });

    }
    //
  }
  setSubmitParameters(createBatchForm: FormGroup) {

    let httpParams: Params = {
      startdate: createBatchForm.get('fromDate').value,
      enddate: createBatchForm.get('toDate').value
    }
    //let pricelisttype : 'ho'
    this.reportsService.createBatchExport().subscribe(res => {
      if (res && res) { //alert("h3"); 
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
          this.router.navigate(['features/providers/retailer/pricelist'])
          this.toastr.success('PriceList added successfully', 'Success', {
            timeOut: 3000,
          });        
      }
      }
    });
  }

  
  ngOnDestroy() {
    super.ngOnDestroy()
  }
}
